import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import { renderStatusColor } from "utils/statusColor";
import DropdownNew from "utils/dropdown";
import Filter, { ActiveFilter } from "components/__new/common/Filter";
import FilterList from "components/__new/common/FilterList";
import DownloadAsCSV from "components/__new/common/DownloadAsCSV";
import Print from "components/__new/common/Print";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import { TableContent } from "components/__new/common/TableContent";
// eslint-disable-next-line no-unused-vars
import { DateFormat, TimeFormat, MonthIndex } from "utils/dateFormat";
import CurrencyFormat from "utils/currencyFormat";
import logger from "utils/logger";
import Pagination from "components/__new/common/pagination";
import Maybe from "components/__new/common/Maybe";
import processParams from "utils/processParams";
import useLoginInfo from "hooks/useLoginInfo";
import { DashboardBox2 } from "components/__new/common/DashboardBox";
import NumberFormat from "utils/numberFormat";
import DialogBox from "utils/dialogBox";
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
import WithdrawalsChart from "assets/images/icons/withdrawals-chart.svg";
import { ReactComponent as IconArrowRight } from "assets/images/icons/project-icons/arrow-right.svg";
import { ReactComponent as IconLoading } from "assets/images/icons/loading-2.svg";
import { ReactComponent as IconTick } from "assets/images/icons/tick.svg";
import { ReactComponent as IconCancel } from "assets/images/icons/cancel.svg";
import { ReactComponent as IconSettings } from "assets/images/icons/settings-01.svg";
import ContentLoading from "components/__new/common/ContentLoading";
import ODPConfiguration from "components/__new/withdrawals/ODPConfiguration";
import WithdrawalReport from "components/__new/withdrawals/WithdrawalsReport";
import * as withdrawalsAction from "store/entities/withdrawals/action";
import EmptyUI from "components/__new/common/EmptyUI";



export const List = () => {
    const location = useLocation();
    const {userInfo} = useLoginInfo();
    const dispatch = useDispatch();
    const {urlQueryParams} = useUrlQueryParams();
    const { InlineRouterTab } = useInlinePageRouter();
    const { withdrawalsMetricsLoading, withdrawalsMetrics, withdrawalsLoading, withdrawals, withdrawalsDownloadLoading, withdrawalsDownload } = useSelector((s) => s.entities.withdrawals);

    const downloadAsCSVRef = useRef();
    const printComponentRef = useRef();
    const [isOpenODPConfiguration, setIsOpenODPConfiguration] = useState(false);
    const [isOpenWithdrawalReport, setIsOpenWithdrawalReport] = useState(false);
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });


    // const getMonthYear = () => {
    //     const date = new Date();
    //     const currentMonthIndex = (date.getMonth() + 1);
    //     let month = MonthName(currentMonthIndex);
    //     let year = date.getFullYear();

    //     return {month, year};
    // }


    const getWithdrawalsMetrics = () => {
        let params = {};
        // const {month, year} = getMonthYear();

        params = processParams(urlQueryParams, params, "dateFilter", "string", listParams?.value, "dateFilter");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        params = processParams(urlQueryParams, params, "month", "string", "", "month");
        params = processParams(urlQueryParams, params, "year", "string", "", "year");
        //  params = processParams(urlQueryParams, params, "value", "string", "", "value");
        //  params = processParams(urlQueryParams, params, "value", "string", listParams.value, "value");
        
        const paramsPayload = addOtherWithdrawalFilters(params);
        dispatch(withdrawalsAction.getWithdrawalsMetrics(paramsPayload));
    }


    const getWithdrawals = () => {
        let params = {...listParams};
        // const {month, year} = getMonthYear();

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        params = processParams(urlQueryParams, params, "month", "string", "", "month");
        params = processParams(urlQueryParams, params, "year", "string", "", "year");

        setListParams(params);
        const paramsPayload = addOtherWithdrawalFilters(params);
        dispatch(withdrawalsAction.getWithdrawals(paramsPayload));
    }


    const statusDisplay = (status) => {
        const data = {
            "cancelled": "rejected",
            "paid": "Approved",
        }
        return data[status?.toLowerCase()] ?? status;
    }


    const modifyDownloadData = (data) => {
        const newData = data?.map((withdrawal) => {
            return {...withdrawal, status: statusDisplay(withdrawal.status)};
        })
        return newData;
    }


    const approveWithdrawal = async (id) => {
        const result = await DialogBox({
			title: "Approve Withdrawal 😊",
			content: "Are you sure you want to approve this withdrawal?",
			buttonYes: "Approve",
			buttonNo: "Cancel",
		});
		if (result) {
            dispatch(withdrawalsAction.approveWithdrawal(id)).then(() => {
                getWithdrawalsMetrics();
                getWithdrawals();
            })
        }
    }


    const rejectWithdrawal = async (id) => {
        const result = await DialogBox({
			title: "Reject Withdrawal 😰",
			content: "Are you sure you want to reject this withdrawal?",
			buttonYes: "Reject",
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
		if (result) {
            dispatch(withdrawalsAction.rejectWithdrawal(id)).then(() => {
                getWithdrawalsMetrics();
                getWithdrawals();
            })
        }
    }

    
    useEffect(() => {
        getWithdrawalsMetrics();
        // eslint-disable-next-line
    }, [listParams?.search, listParams?.month, listParams?.year, listParams?.value]);
    // [listParams?.search, listParams?.month, listParams?.year, listParams?.value]);

    useEffect(() => {
        logger("employer-withdrawal-listings", userInfo);
        getWithdrawals();
        // eslint-disable-next-line
    }, [location]);
    
    const handleFilterChange = (value = "") => {
        setListParams({...listParams, value});
    }

// today, 7days, thisMonth, lastMonth, yearToDate'
    return (
        <div>

            <DynamicHeadTag
                headerText="Withdrawals"
                headerDescription="See all withdrawals made by your employees in one place."
            />
            
            <ODPConfiguration
                isOpen={isOpenODPConfiguration}
                setIsOpen={setIsOpenODPConfiguration}
            />

            <WithdrawalReport
                isOpen={isOpenWithdrawalReport}
                setIsOpen={setIsOpenWithdrawalReport}
            />

            <div>
                <div style={{ marginBottom: '14px'}} className="flex w-full justify-between items-center">
                    <h3 style={{ fontSize: '18px', lineHeight: '28px',}} className="font-medium text-ep-black pt-0">Withdrawals Overview</h3>
                    <div className="">
                            <FilterList 
                                handleFilterChange={handleFilterChange}
                                options={[
                                    {
                                        name: "Today",
                                        value: "today",
                                    },
                                    {
                                        name: "Last 7 Days",
                                        value: "7days",
                                    },
                                    {
                                        name: "This Month",
                                        value: "thisMonth",
                                    },
                                    {
                                        name: "Last Month",
                                        value: "lastMonth",
                                    },
                                    {
                                        name: "Year to Date",
                                        value: "yearToDate",
                                    },
                                ]}
                            />
                        </div>
                </div>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    <div className="h-full px-4 sm:px-6 py-2 sm:py-3 relative bg-white shadow-sm overflow-hidden"  style={{borderRadius: '12px'}}>
                        <div className="text-[#717171] mr-3">On-Demand Withdrawals</div>
                        <div className="mt-2 w-full h-24">
                            <img src={WithdrawalsChart} alt="chart" className="h-full object-contain relative -left-2" />
                        </div>
                        <div className="mt-2">
                            <button type="button" onClick={() => setIsOpenWithdrawalReport(true)} className="btn btn-transparent-primary rounded-lg">
                                View Withdrawal Trend
                                <IconArrowRight className="ml-2" />
                            </button>
                        </div>
                    </div>
                    
                    <div className="bg-white overflow-hidden" style={{borderRadius: '12px'}}>
                        <DashboardBox2
                            icon={<div className="w-10 h-10 p-1.5 flex-shrink-0 rounded-full bg-[#ECFDF3] border-2 border-[#d5e6df]">
                                <IconTick className="w-full h-full object-contain" />
                            </div>}
                            title="Approved"
                            loading={withdrawalsMetricsLoading}
                            value={CurrencyFormat(withdrawalsMetrics?.data?.approved?.amount) ?? "-"}
                            subtext={<>
                                <div className="mt-4 text-sm text-[#1A202C] tracking-wider">
                                    Withdrawals count
                                </div>
                                <div className="text-xl font-bold flex items-center">
                                    <ContentLoading
                                        loading={withdrawalsMetricsLoading}
                                        data={NumberFormat(withdrawalsMetrics?.data?.approved?.count, "no-kobo") ?? "-"}
                                    />
                                    <Maybe condition={withdrawalsMetricsLoading === false}>
                                        <div className="label ml-3 h-6 font-normal text-sm text-[#027A48] bg-[#ECFDF3]">
                                            +{withdrawalsMetrics?.data?.approved?.countPercentChange}% compared to last month
                                        </div>
                                    </Maybe>
                                </div>
                            </>}
                        />
                    </div>
                    
                    <div className="bg-white overflow-hidden" style={{borderRadius: '12px'}}>
                        <DashboardBox2
                            icon={<div className="w-10 h-10 p-1.5 flex-shrink-0 rounded-full bg-[#FEF5E7] border-2 border-[#fbf1df]">
                                <IconLoading className="w-full h-full object-contain" />
                            </div>}
                            title="Pending Withdrawals"
                            loading={withdrawalsMetricsLoading}
                            value={CurrencyFormat(withdrawalsMetrics?.data?.pending?.amount) ?? "-"}
                            subtext={<>
                                <div className="mt-4 text-sm text-[#1A202C] tracking-wider">
                                    Count
                                </div>
                                <div className="text-xl font-bold">
                                    <ContentLoading
                                        loading={withdrawalsMetricsLoading}
                                        data={NumberFormat(withdrawalsMetrics?.data?.pending?.count, "no-kobo") ?? "-"}
                                    />
                                </div>
                            </>}
                        />
                    </div>
                    
                    <div className="bg-white overflow-hidden" style={{borderRadius: '12px'}}>
                        <DashboardBox2
                            icon={<div className="w-10 h-10 p-1.5 flex-shrink-0 rounded-full bg-[#FEF2F2] border-2 border-[#f9e4e3]">
                                <IconCancel className="w-full h-full object-contain" />
                            </div>}
                            title="Rejected Withdrawals"
                            loading={withdrawalsMetricsLoading}
                            value={CurrencyFormat(withdrawalsMetrics?.data?.unapproved?.amount) ?? "-"}
                            subtext={<>
                                <div className="mt-4 text-sm text-[#1A202C] tracking-wider">
                                    Count
                                </div>
                                <div className="text-xl font-bold">
                                    <ContentLoading
                                        loading={withdrawalsMetricsLoading}
                                        data={NumberFormat(withdrawalsMetrics?.data?.unapproved?.count, "no-kobo") ?? "-"}
                                    />
                                </div>
                            </>}
                        />
                    </div>
                </div>
            </div>


            <div className="mt-6 flex items-center">
                <InlineRouterTab
                    queryMode={true}
                    items={[
                        {
                            title: "Withdrawals",
                            type: "query",
                            queryName: "status",
                            queryValue: "",
                        },
                        {
                            title: "Requests",
                            type: "query",
                            queryName: "status",
                            queryValue: "pending",
                        }
                    ]}
                />
            </div>
                
        
            <div className="mt-6 box !px-0 !pb-0">
                <div className="px-4 font-medium text-xl">
                    {location.search === "?status=pending" ? "Requests" : "Withdrawals"}
                </div>
                
                <div className="mt-6 px-4 flex flex-wrap justify-between">
                    <div className="max-w-sm flex-grow sm:mr-6">
                        <SearchBox placeholder="Search Employee" name="search" extraUrlParams="page=1" />
                    </div>
                    <div className="flex flex-wrap space-x-3">
                        <div>
                            <Filter filters={[
                                {
                                    title: "Status",
                                    name: "status",
                                    dataType: "select",
                                    options: [
                                        {
                                            display: "All",
                                            payload: "",
                                        },
                                        {
                                            display: "Approved",
                                            payload: "paid",
                                        },
                                        {
                                            display: "Rejected",
                                            payload: "cancelled",
                                        },
                                        {
                                            display: "Pending",
                                            payload: "pending",
                                        },
                                    ],
                                },
                                {
                                    title: "Month & Year",
                                    dataType: "month-year",
                                    option: {
                                        name: "month-year",
                                        placeholder: "Select",
                                    },
                                },
                            ]}/>
                        </div>

                        <div>
                            <DownloadAsCSV
                                ref={downloadAsCSVRef}
                                tooltip="Download withdrawals list"
                                filename="Withdrawals.csv"
                                columns={[
                                    { label: "Date Withdrawn", key: "date" },
                                    { label: "First Name", key: "employeeId.firstName" },
                                    { label: "Last Name", key: "employeeId.lastName" },
                                    { label: "Job Title", key: "employeeId.jobTitle" },
                                    { label: "Email Address", key: "employeeId.email" },
                                    { label: "Phone Number", key: "employeeId.phoneNumber" },
                                    { label: "Amount Withdrawn", key: "amountRequested" },
                                    { label: "Fee", key: "fee" },
                                    { label: "Status", key: "status" },
                                ]}
                                click={() => {
                                    dispatch(withdrawalsAction.downloadWithdrawals(addOtherWithdrawalFilters({...listParams, page: 1, limit: 10000}))).then(() => {
                                        downloadAsCSVRef.current?.downloadData();
                                    });
                                }}
                                loading={withdrawalsDownloadLoading}
                                response={modifyDownloadData(withdrawalsDownload?.data?.withdrawals)}
                            />
                        </div>

                        <div>
                            <div onClick={() => setIsOpenODPConfiguration(true)} className="btn px-3 text-sm border border-gray-300 flex items-center cursor-pointer">
                                <IconSettings className="h-5" />
                                <span>Configuration</span>
                            </div>
                        </div>
                        
                        <div>
                            <Print component={printComponentRef} />
                        </div>
                    </div>
                </div>

                <div className="px-4">
                    <ActiveFilter filters={{"Status": "status", "Month & Year": "month-year"}} />
                </div>
                
                <div className="mt-6">
                    <div ref={printComponentRef}>
                        
                        <div className="mb-4 text-xl hidden print:block">
                            Withdrawals
                        </div>
                        
                        <Table>
                            <Table.Head>
                                <th>Employee Information</th>
                                <th>Email</th>
                                <Maybe condition={urlQueryParams?.status === "" || urlQueryParams?.status === undefined}>
                                    <th>Date of Withdrawal</th>
                                    <th>Amount Withdrawn</th>
                                </Maybe>
                                <Maybe condition={urlQueryParams?.status === "pending"}>
                                    <th>Amount Requested</th>
                                    <th>Date of Request</th>
                                </Maybe>
                                <th>Status</th>
                                <th></th>
                            </Table.Head>
                            <Table.Body>

                                <TableContent
                                    loading={withdrawalsLoading}
                                    loadingText="Loading withdrawals"
                                    data={withdrawals?.data?.withdrawals}
                                    total={withdrawals?.data?.total}
                                    colspan={5}
                                    emptyUI={<EmptyUI
                                        text={urlQueryParams?.status === "pending" ? "No Request has been made yet" : "No withdrawals has been made yet"}
                                    />}
                                />

                                {withdrawalsLoading === false && withdrawals?.data?.withdrawals?.map((withdrawal) =>
                                    <tr key={withdrawal?._id}>
                                        <td>
                                            <div className="capitalize text-black font-medium">
                                                <Maybe condition={withdrawal?.employeeId?.fullName !== undefined}>
                                                    {withdrawal?.employeeId?.fullName ?? "-"}
                                                </Maybe>
                                                <Maybe condition={withdrawal?.employeeId?.fullName === undefined}>
                                                    {withdrawal?.employeeId?.firstName ?? "-"} {withdrawal?.employeeId?.lastName}
                                                </Maybe>
                                            </div>
                                            <div className="text-fade">
                                                {withdrawal?.employeeId?.jobTitle ?? "-"}
                                            </div>
                                        </td>
                                        <td>
                                            {withdrawal?.employeeId?.email ?? "-"}
                                        </td>
                                        <td>
                                            <Maybe condition={urlQueryParams?.status === "" || urlQueryParams?.status === undefined}>
                                                {withdrawal?.date ? DateFormat(withdrawal?.date) + " at " + TimeFormat(withdrawal?.date) : "-"}
                                            </Maybe>
                                            <Maybe condition={urlQueryParams?.status === "pending"}>
                                                {CurrencyFormat(withdrawal?.amountRequested) ?? "-"}
                                            </Maybe>
                                        </td>
                                        <td>
                                            <Maybe condition={urlQueryParams?.status === "" || urlQueryParams?.status === undefined}>
                                                {CurrencyFormat(withdrawal?.amountRequested) ?? "-"}
                                            </Maybe>
                                            <Maybe condition={urlQueryParams?.status === "pending"}>
                                                {withdrawal?.date ? DateFormat(withdrawal?.date) + " at " + TimeFormat(withdrawal?.date) : "-"}
                                            </Maybe>
                                        </td>
                                        <td>
                                            <div className={"label capitalize " + renderStatusColor(withdrawal?.status)}>
                                                {statusDisplay(withdrawal?.status) ?? "-"}
                                            </div>
                                            {/* 
                                            <Maybe condition={withdrawal?.status === "pending"}>
                                                <div className="w-20 text-xs text-center">
                                                    Awaiting
                                                    <br />
                                                    employer
                                                    <br />
                                                    approval
                                                </div>
                                            </Maybe>
                                             */}
                                        </td>
                                        <td>
                                            <Maybe condition={withdrawal?.status === "pending"}>
                                                <DropdownNew>
                                                    <></>
                                                    <div>
                                                        <div onClick={() => approveWithdrawal(withdrawal?._id)} className="dropdown-item">Approve Withdrawal</div>
                                                        <div onClick={() => rejectWithdrawal(withdrawal?._id)} className="dropdown-item text-red-500">Reject Withdrawal</div>
                                                    </div>
                                                </DropdownNew>
                                            </Maybe>
                                        </td>
                                    </tr>
                                )}

                            </Table.Body>
                        </Table>

                        <Maybe condition={withdrawalsLoading === false && withdrawals?.data?.withdrawals?.length > 0}>
                            <div className="mt-6">
                                <Pagination data={withdrawals?.data} limit={listParams.limit} />
                            </div>
                        </Maybe>

                    </div>
                </div>
            </div>

        </div>
    )
}


export const addOtherWithdrawalFilters = (params) => {
    let paramsPayload = {...params};

    if (params.search){
        if (isNaN(params.search)){
            paramsPayload = {
                ...paramsPayload,
                search: params.search,
            }
            delete paramsPayload["amount"];
        }
        else{
            paramsPayload = {
                ...paramsPayload,
                amount: params.search,
            }
            delete paramsPayload["search"];
        }
    }

    if (params.month && params.year){
        paramsPayload = {
            ...paramsPayload,
            month: MonthIndex(params.month),
            year: params.year,
        };
    }

    return paramsPayload;
}


export default List;
